import { useState } from "react"
import styles from "./index.module.scss"

export const Tooltip = ({ icon, name, isOnlyAccessModuleCiq, fnHandleClick }) => {
  const [visible, setVisible] = useState(false)

  const showTooltip = () => setVisible(true)
  const hideTooltip = () => setVisible(false)

  return (
    <div className={styles.tooltipContainer} onClick={fnHandleClick}>
      <div
        style={{ cursor: isOnlyAccessModuleCiq ? "not-allowed" : "default" }}
        className={styles.icon}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
      >
        {icon}
      </div>
      {visible && <div className={styles.tooltip}>{name}</div>}
    </div>
  )
}
